/* Перерисовка программ на главной станице в блоке Products */
const initFilters = () => {
  const itemsContainer = document.getElementById("products");

  if (!itemsContainer) return;

  const linksPrograms = itemsContainer.querySelectorAll(".tile__link");

  if (linksPrograms.length > 0) {
    let count = 0;
    
    linksPrograms.forEach((tile) => {
      if (count == 4) {
        count = 0;
      }

      count++;
      changeStateTiles(tile, count);
    });
  }

  /* Отобраение и замена цвета у карточек каталога */
  function changeStateTiles(tile, count) {
    const colors = [
      ["#FFB84F", "#FFC877"],
      ["#FF9F9F", "#FFBABE"],
      ["#64BBFF", "#82C7FC"],
      ["#9896FF", "#AFAEF2"],
    ];

    tile.closest(".tile").style.backgroundColor = colors[count - 1][0];
    tile
      .closest(".tile")
      .querySelectorAll(".tile__header-icon")
      .forEach((icon) => (icon.style.backgroundColor = colors[count - 1][1]));

    tile.closest(".tile").style.display = "flex";
    tile.closest(".tile").classList.add("visible");

    if (tile.closest(".disable")) {
      tile.closest(".tile").style.display = "none";
    }
  }
};

export default initFilters;
